import { Case, Nullable } from '@bybeam/platform-types';
import React, { useContext } from 'react';

export const CaseContext = React.createContext<{ case_: Nullable<Case>; refetch?: () => void }>({
  case_: undefined,
});

export default function useCase(): { case_: Nullable<Case>; refetch?: () => void } {
  return useContext(CaseContext);
}
